module.exports = require("./fr-GP.js");